define('shared/initializer/form/newHouseAdapters/mixins/LeadSubmittable',[
    'shared/lib/RSVP',
    'shared/lib/deepmerge',
    'shared/remote/lead/create',
    'shared/initializer/form/constants',
    '../util/getLeadETag',
    '../util/getTrackingPayload',
    '../util/getReferredPayload',
    '../util/getMiscPayload',
    'shared/util/state',
    'shared/my/efid',
    './SubscriptionsSavable'
], 
function(
    RSVP,
    deepmerge,
    createLead,
    constants,
    getLeadETag,
    getTrackingPayload,
    getReferredPayload,
    getMiscPayload,
    state,
    myEFID,
    SubscriptionsSavable
){
    function Ctor() {}

    function getFieldValue(fieldName) {
        var me = this;
        return me.items.get(fieldName) && me.items.get(fieldName).$el.val();
    }

    Ctor.prototype.doSubmit = function() {
        var me = this;

        return RSVP.resolve()
            .then(function(){
                return RSVP.all([
                    getLeadETag(), 
                    getTrackingPayload(), 
                    getReferredPayload(), 
                    myEFID.get(), 
                    state.get('user.ef_id'),
                    getMiscPayload(),
                    state.get(SubscriptionsSavable.STATE_KEY)
                ]);
            })
            .then(function(values){
                var etag = values[0];
                var tracking = values[1];
                var referred = values[2];
                var efid = values[3];
                var efGUID = values[4][0];
                var misc = values[5];
                var subscriptions = values[6][0];
                var options = deepmerge({
                    name: {
                        given: getFieldValue.call(me, constants.FIELD.LEAD.FIRSTNAME),
                        family: getFieldValue.call(me, constants.FIELD.LEAD.LASTNAME),
                    },
                    email: getFieldValue.call(me, constants.FIELD.Email),
                    phones: {
                        telephone: getFieldValue.call(me, constants.FIELD.PHONE),
                    },
                    etag: etag,
                    market: getFieldValue.call(me, constants.FIELD.LEAD.LOCAL),
                    lead: {
                        type: me.type
                    },
                    ageGroup: getFieldValue.call(me, constants.FIELD.LEAD.AGE_GROUP),
                    postcode: getFieldValue.call(me, constants.FIELD.LEAD.POSTCODE),
                    callTime: getFieldValue.call(me, constants.FIELD.LEAD.CALL_TIME),
                    subscriptions: subscriptions,
                    tracking: tracking,
                    referred: referred,
                    EFID: efid,
                    EFGuid: efGUID
                }, misc);

                return createLead(options);
            });
    };

    return Ctor;
});


